import { CellContext, createColumnHelper } from '@tanstack/react-table'
import { Member } from '../../types/MemberTypes'
import { DeviceInformation } from '../../types/DeviceTypes'

export const addDevicesColumns = (checkedItems: Member[], handleCheckboxChange: (email: string) => void) => {
  const columnHelper = createColumnHelper<Member>()

  const columnHelpers = [
    {
      id: 'selection',
      cell: (row: CellContext<DeviceInformation, string>) => {
        return (
          <div className="ml-4 mt-1.5">
            <input
              key={row.row.original.email}
              id={row.row.original.email}
              type="checkbox"
              className="h-8 w-8 text-blue-600 border-gray-800 rounded focus:ring-mainPurple checked:bg-mainPurple dark:border-gray-200 dark:bg-transparent dark:checked:bg-mainPurple scale-50"
              checked={checkedItems.some((item) => item.email === row.row.original.email)}
              onChange={() => {
                handleCheckboxChange(row.row.original.email)
              }}
            />
          </div>
        )
      },
    },
    columnHelper.accessor('name', {
      header: 'Name',
    }),
    columnHelper.accessor('email', {
      header: 'Email',
    }),
  ]

  return columnHelpers
}
